import { globalVariables } from "helper/globalVariables";
import { pending } from "helper/icons";
import { forwardRef, useImperativeHandle, useRef } from "react";
import { Button } from "shared/Components/button";
import Modal from "shared/Components/modal";
import { OutlineButton } from "shared/Components/outlineButton";

export const SkipModal = forwardRef((props, ref) => {
  const {
    onSkip,
    ModalHeader,
    ModalContent = globalVariables.registeringDogParticipate,
    hasSecondaryButton = true,
    isCenter = false,
    primaryLabel = globalVariables.yes,
    showClose = false,
  } = props || {};
  const modalRef = useRef();

  useImperativeHandle(ref, () => ({
    openModal() {
      modalRef.current.openModal();
    },
  }));

  return (
    <Modal showClose={showClose} ref={modalRef}>
      <div
        className={`flex text-center flex-col ${
          isCenter ? "items-center" : "items-start"
        } w-[300px] md:w-[371px] sm:w-[300px]`}
      >
        <img src={pending} alt="" className="w-12 h-12 mb-3 self-center" />
        <span className="font-semibold text-lg text-gray-900 mb-2 text-center">
          {ModalHeader == null ? globalVariables.sureSkip : ModalHeader}
        </span>
        <span className="font-medium text-md text-gray-600 mb-6">
          {ModalContent}
        </span>
          <div className="flex flex-row">
            {hasSecondaryButton && (
              <OutlineButton
                onClick={() => modalRef.current.closeModal()}
                width={"w-36 md:w-44"}
                label={globalVariables.no}
              />
            )}
            <div className="ml-3" />
            <Button
              onClick={() => {
                onSkip();
                modalRef.current.closeModal();
              }}
              width={"w-36 md:w-44"}
              label={primaryLabel}
            />
          </div>
      </div>
    </Modal>
  );
});
